var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 67.8 50.6"
    },
    viewBox: "0 0 67.8 50.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1199.3 1747h2.5l-1.3-2.1-2.4 3.9h-1.1l3-4.7c.1-.2.3-.3.6-.3.2 0 .4.1.6.3l3 4.7h-1.1l-.5-.9h-2.5l-.8-.9zm11.6.9v-4h-.9v4.4c0 .1.1.2.1.3.1.1.2.1.3.1h4.3l.6-.9h-4.4zm-15.6-.7c.9.1 1.7-.6 1.8-1.5.1-.9-.6-1.7-1.5-1.8h-4.3v4.9h.9v-4h3.1c.4.1.8.5.7.9 0 .4-.3.7-.7.7h-2.7l2.8 2.5h1.4l-1.9-1.6.4-.1zm-10 1.6c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h2.9c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5h-2.9zm2.8-.9c.9 0 1.6-.7 1.6-1.5 0-.9-.7-1.6-1.5-1.6h-2.9c-.9 0-1.6.7-1.6 1.5 0 .9.7 1.6 1.5 1.6h2.9zm18 .9c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h3.4l-.6.9h-2.8c-.9 0-1.6.8-1.5 1.6 0 .8.7 1.5 1.5 1.5h3.4l-.6.9-2.8.1zm11.5-.9c-.7 0-1.3-.5-1.5-1.2h4l.6-.9h-4.6c.2-.7.8-1.2 1.5-1.2h2.8l.6-.9h-3.4c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5h2.9l.6-.9-3.5.1",
    style: {
      fill: "#e50019"
    },
    transform: "translate(-1175 -1724.682)"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fontSize: 6,
      fontFamily: "&quot"
    },
    transform: "translate(7.544 30.445)"
  }, "Cloud Infrastructure"));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC10);
export default __webpack_public_path__ + "static/media/c10.c4078e1ebd4ea949cc5fc7b5f1b92d31.svg";
export { ForwardRef as ReactComponent };